export const extractTextFromHTML = htmlString => {
  if (!htmlString) return htmlString
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = htmlString
  return tempDiv.textContent || tempDiv.innerText || ''
}
